import { html } from 'lit';
import { PurchaseOrder, PurchaseOrderState } from '../../api/dealer-api-interface-franchisee';
import { LangPurchaseOrderHelperFunctions } from '../../../localization/scripts/purchase-orders/purchase-order-helper-functions-lang';
import { glossary } from '../../../localization/global';

export const getPurchaseOrderNumberFormatted = (p: PurchaseOrder | null) => {
  if (!p) return '';

  return p.purchaseOrderNumber == 0
    ? LangPurchaseOrderHelperFunctions.draft()
    : LangPurchaseOrderHelperFunctions.purchaseOrderAbbrev({
        purchaseOrderNumber: p.purchaseOrderNumber.toString().padStart(6, '0')
      });
};

export const getPurchaseOrderTitle = (p: any) => {
  const po = p as PurchaseOrder;
  const poNumber = getPurchaseOrderNumberFormatted(po);

  return html`${poNumber} ${po.title} ${getPurchaseOrderStatus(po.state, true)}`;
};

export const getPurchaseOrderStatus = (state: number, asBadge = false) => {
  if (!asBadge) return html`${PurchaseOrderState[state]}`;

  const value = PurchaseOrderState[state].toLowerCase();
  const text = glossary(`purchase-order-state-${value}`);

  return html`<span class="badge badge-${value}">${text}</span>`;
};

export const getPurchaseOrderStatusStr = (state: number) => {
  const value = PurchaseOrderState[state].toLowerCase();
  const text = glossary(`purchase-order-state-${value}`);

  return text;
};
